import { AreaSchema } from "./Area";
import * as z from "zod";

export const FloorPlanSchema = z.object({
  areas: z.array(AreaSchema),
});

export type FloorPlan = z.infer<typeof FloorPlanSchema>;
